import { ContainerProps } from "@chakra-ui/react"

import { useMobileScreen } from "#/shared/hooks"

import FullHeightPage from "./FullHeightPage"

export default function GridContainer({ children, ...props }: ContainerProps) {
  const isMobileScreen = useMobileScreen()

  return (
    <FullHeightPage
      px={isMobileScreen ? 10 : 16}
      pb={10}
      maxW="1260px"
      mx={0}
      {...props}
    >
      {children}
    </FullHeightPage>
  )
}
